import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomModal } from "../../../components/CustomModal";
import { MDBBtn } from "mdb-react-ui-kit";
import API from "../../../service/api";
import { CodeInput } from "../../../components/CodeInput";
import { Alert } from "../../../components/Alert";

export interface AddSharedGroupModalProps {
    open: boolean;
    onJoin: (id: number) => void;
    onClose: () => void;
}
export const AddSharedGroupModal = ({open, onJoin, onClose}: AddSharedGroupModalProps) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setError('');
    }, [code]);

    const join = useCallback(() => {
        setLoading(true);
        API.POST('/api/admgroups/share', {invitationId: code})
            .then(({groupId}) => onJoin(groupId))
            .catch(err => {setError(err.message); })
            .finally(() => setLoading(false));

    }, [code]);

    useEffect(() => {
        if (!open) return;
        setCode('');
        setError('');
        setLoading(false);
    }, [open]);

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={t('add_shared_group')}
            footer={(
                <MDBBtn disabled={code.length < 6 || loading} onClick={join}>{t('add')}</MDBBtn>
            )}
        >
                <h6>{t('insert_invitation_code')}:</h6>

                <div className="d-flex flex-row justify-content-center">
                    <CodeInput onCodeChange={c => setCode(c)}/>
                </div>
                <Alert type="danger" message={error}/>
        </CustomModal>
    )
}